import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var Route = _ref => {
  var {
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    fill: "none",
    viewBox: "0 0 24 24",
    "data-testid": "route",
    className: clsx('stroke-current', className)
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M11.5 5h.4344c3.0472 0 4.5709 0 5.1492.5473.5.473.7215 1.17.5866 1.845-.1562.7807-1.4001 1.6605-3.8879 3.4202l-4.0646 2.875C7.23 15.4471 5.986 16.327 5.8298 17.1078a2 2 0 0 0 .5866 1.8449c.5783.5473 2.102.5473 5.1492.5473H12.5M8 5c0 1.6569-1.3431 3-3 3-1.6568 0-3-1.3431-3-3 0-1.6568 1.3432-3 3-3 1.6569 0 3 1.3432 3 3Zm14 14c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3 1.3431-3 3-3 3 1.3431 3 3Z"
    })
  }));
};
export default Route;